/**
 * Directiva para mostrar el spiner de carga
 */
sigoLoading.$inject = ['lang'];
export default function sigoLoading(lang) {
    var textos = {
        es: {
            cargando: 'Cargando'
        },
        ca: {
            cargando: 'Carregant'
        }
    };
    return {
        restrict: 'A',
        transclude: true,
        scope: {
            'sigoLoading': '=',
            'centrado': '='
        },
        link: function (scope, element, attrs) {
            scope.sigoLoading = true;
            scope.textoCargando = textos[lang].cargando;

            if (scope.centrado) {
                scope.styleContendor1 = {};
                scope.styleContendor2 = {'margin-top': '200px'};
            } else {
                scope.styleContendor1 = {'position': 'inherit'};
                scope.styleContendor2 = {};
            }
        },
        template: require('./sigoLoadingView.html')
    }
}